








































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Types
import { ICountry } from "@/models/constants";

@Component({
  components: {
    "country-select": () => import("@/components/base/CountrySelect.vue")
  }
})
export default class SelectCountriesField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: ICountry["id"][];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isRestricted = false; // Use for all
  public savedValue: ICountry["id"][] = [];

  public created() {
    this.isRestricted = !this.$_.isEmpty(this.value);
    this.savedValue = this.isRestricted ? this.value : [];
  }

  // Getters

  public get selectedCountries() {
    return this.value;
  }

  public isRestrictedChanged(value) {
    this.isRestricted = value;

    this.$emit("input", this.isRestricted ? this.savedValue : []);
  }

  // Watchers

  @Watch("selectedCountries")
  public onSelectedCountriesChange(value, oldValue) {
    this.savedValue = oldValue;
  }
}
